import CanShow from "./CanShow";
import Settings from "@/features/settings/Index";
import Users from "@/features/settings/users/Index";
import EditUser from "@/features/settings/users/Edit";
import CreateUser from "@/features/settings/users/Create";
import GeneralSettings from "@/features/settings/generalSettings/Index";
import ServicesConnection from "@/features/settings/servicesConnection/Index";
import MessagesControl from "@/features/settings/messagesControl/Index";
import Info from "@/features/settings/associationManager/Info";
import Licenses from "@/features/settings/associationManager/Licenses";
import Contacts from "@/features/settings/associationManager/Contacts";
import AssociationManager from "@/features/settings/associationManager/Index";
import BankAccounts from "@/features/settings/associationManager/BankAccounts";
import Interface from "@/features/settings/associationManager/Interface";
import Classifications from "@/features/settings/classifications/pages/index";
import ImportData from "@/features/settings/import/Index";
import Logs from "@/features/settings/logs/Index";
import Integrations from "@/features/settings/integrations/Index";
import PaymentsIntegration from "@/features/settings/integrations/payments/Index";
import WhatsappIntegration from "@/features/settings/integrations/whatsapp/Index";
import SmsIntegration from "@/features/settings/integrations/sms/Index";

export const settingsRoutes = [
  {
    path: "/all-settings",
    element: (
      <CanShow
        page={<Settings />}
        ifHas={["generalSettings", "serviceLinkSettings", "permissions"]}
      />
    ),
  },
  {
    path: "/settings-general",
    element: <CanShow page={<GeneralSettings />} ifHas={["generalSettings"]} />,
  },
  {
    path: "/settings-services-connection",
    element: (
      <CanShow page={<ServicesConnection />} ifHas={["serviceLinkSettings"]} />
    ),
  },
  {
    path: "/settings-integrations",
    element: (
      <CanShow page={<Integrations />} ifHas={["serviceLinkSettings"]} />
    ),
  },
  {
    path: "/settings-integrations/payments",
    element: (
      <CanShow page={<PaymentsIntegration />} ifHas={["serviceLinkSettings"]} />
    ),
  },
  {
    path: "/settings-integrations/whatsapp",
    element: (
      <CanShow page={<WhatsappIntegration />} ifHas={["serviceLinkSettings"]} />
    ),
  },
  {
    path: "/settings-integrations/sms",
    element: (
      <CanShow page={<SmsIntegration />} ifHas={["serviceLinkSettings"]} />
    ),
  },
  {
    path: "/settings-users",
    element: <CanShow page={<Users />} ifHas={["permissions"]} />,
  },
  {
    path: "/settings-users/create",
    element: <CanShow page={<CreateUser />} ifHas={["permissions"]} />,
  },
  {
    path: "/settings-users/:id/edit",
    element: <CanShow page={<EditUser />} ifHas={["permissions"]} />,
  },
  {
    path: "/settings-control",
    element: <CanShow page={<MessagesControl />} ifHas={["editSmsMessage"]} />,
  },
  {
    path: "/association-manager",
    element: (
      <CanShow
        page={<AssociationManager />}
        ifHas={["associationData", "editAssociationData"]}
      />
    ),
    children: [
      { path: "info", element: <Info /> },
      { path: "interface", element: <Interface /> },
      { path: "licenses", element: <Licenses /> },
      { path: "contacts", element: <Contacts /> },
      { path: "bank-accounts", element: <BankAccounts /> },
    ],
  },
  {
    path: "/classifications",
    element: (
      <CanShow page={<Classifications />} ifHas={["editAssociationData"]} />
    ),
  },
  {
    path: "/import-data",
    element: <CanShow page={<ImportData />} ifHas={["importData"]} />,
  },
  {
    path: "/logs",
    element: <CanShow page={<Logs />} ifHas={["showLogs"]} />,
  },
];
